module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-2-c24dded7ee1d9acc906f2f81c9390136.jpg";